/*
 * 项目部署在外网时，由于历史原因，部分返回的图片等资源url为内网地址，这将导致资源不可访问
 * 本模块提供了简易的前端解决方案，将url中的内网ip或指定domain替换为同源或指定地址，以使图片等资源正常显示
 */

/**
 * 替换规则配置
 * 例：当前网页地址栏：http://192.168.111.111/vesionbook
 * 例：图片资源地址：  https://192.168.12.84:30077/home/dashboard/1.jpg
 * 1、最新检查openUrlReplace有无开启，若有则进入下一步
 * 2、优先检查replaceList有无匹配内容
 *    例：["https://www.baidu.com:2222/","192.168.12.84","http://10.32.45.43:999"],此方法将遍历该数组，抽出核心domain部分与url
 *    domain部分做对比，即['www.baidu.com',"192.168.12.84",'10.32.45.43]是否有命中目标，若有则开始下一步处理，并结束遍历
 * 3、查看配置onlyReplaceDomainAndIp是否开启，若是则只替换domain部分，如本例会将【http://192.168.12.84:30077/home/dashboard/1.jpg】
 *    替换为【http://192.168.111.111/home...】;若为否，则保持协议和端口部分，替换为【https://192.168.111.111:30077/home...】
 * 4、查看filterIntranet是否开启，若是，则进行内网地址判断和替换，例如【192.168.12.84】是内网地址将被替换为【192.168.111.111】
 *    协议端口替换规则同步骤3
 */
// interface IReplaceOptions {
// 	/** 是否根据当前地址灵活替换 */
// 	autoReplace?: boolean;
// 	/** 是否开启替换功能，默认开启 */
// 	openUrlReplace?: boolean;
// 	/** 指定要替换的domain格式，注意顺序，仅匹配到第一个可匹配的 */
// 	replaceList?: string[];
// 	/** 是否开启内网替换，默认开启 */
// 	filterIntranet?: boolean;
// 	/** 是否只替换ip或domain，默认开启 */
// 	onlyReplaceDomainAndIp?: boolean;
// 	/** path前增加的额外后缀 */
// 	suffix?: string;
//  /** 要替换到的目标地址 */
//  targetUrl: string;
// }

// 匹配带或者不带端口号的ip
// prettier-ignore
// const ipReg = /(?<=\/|(http|https|ws|wss):\/\/|\b)(([01]{0,1}\d{0,1}\d|2[0-4]\d|25[0-5])\.){3}([01]{0,1}\d{0,1}\d|2[0-4]\d|25[0-5])(:\d{1,5})?/;
// 匹配带或者不带端口号的域名
// prettier-ignore
// eslint-disable-next-line no-useless-escape
// const domainReg = /(?<=\/|(http|https|ws|wss):\/\/|\b)[a-zA-Z0-9][-_\.a-zA-Z0-9]{0,62}(:\d{1,5})?(?=\/)/;

// ios只能支持以下写法（ios不支持零宽断言）
/**
 * 111.122.122.111:12 -> 111.122.122.111:12
 * http://111.122.122.111:1278977 -> http://111.122.122.111:12789
 * ://111.122.122.111:1278977/ -> null
 * //111.122.122.111:1278977/ -> //111.122.122.111:12789
 * /111.122.122.111:1278977/ -> /111.122.122.111:12789
 */
const ipReg = /^(((http|https):)?\/?\/|\b)((2(5[0-5]|[0-4]\d))|1\d{2}|[1-9]?\d)(\.((2(5[0-5]|[0-4]\d))|1\d{2}|[1-9]?\d)){3}(:\d{1,5})?/;
/**
 * aaa11.122.122.111:127bbb8977/ -> 11.122.122.111:127
 */
const ipInnerReg = /((2(5[0-5]|[0-4]\d))|1\d{2}|[1-9]?\d)(\.((2(5[0-5]|[0-4]\d))|1\d{2}|[1-9]?\d)){3}(:\d{1,5})?/;
// eslint-disable-next-line no-useless-escape
const domainReg = /^(((http|https):)?\/?\/|\b)[a-zA-Z0-9][-_\.a-zA-Z0-9]{0,62}(:\d{1,5})?\//;
// eslint-disable-next-line no-useless-escape
const domainInnerReg = /[a-zA-Z0-9][-_\.a-zA-Z0-9]{0,62}(:\d{1,5})?\//;
// 获取链接信息
function getOriginInfoFromSrc(src = '') {
  // prettier-ignore
  let protocol = "", domain = "", port = "", restPath = "", type = "";
  const [host] = src.match(ipReg) || [];
  if (host) {
    type = 'ip';
    const [innerHost] = host.match(ipInnerReg);
    [protocol, restPath] = src.split(innerHost);
    [domain, port = ''] = innerHost.split(':');
  } else {
    const numOfSlashes = src.split('/').length - 1;
    // 斜杠为0,1,2时，往后补一个/，以便正则匹配
    const nowSrc = [0, 1, 2].includes(numOfSlashes) && src.slice(-1) !== '/' ? src + '/' : src;
    const [host2] = nowSrc.match(domainReg) || [];
    if (host2) {
      type = 'domain';
      let [innerHost2] = host2.match(domainInnerReg);
      innerHost2 = innerHost2?.slice(0, -1);
      [protocol, restPath] = src.split(innerHost2);
      [domain, port = ''] = innerHost2.split(':');
    }
  }
  return { protocol, domain, port, restPath, type };
}
// 检测ip是否为内网ip
function checkIntranetIp(ip) {
  const ipArr = ip.split('.');
  if (ipArr[0] == '10' || ipArr[0] == '127') return true;
  if (ipArr[0] == '172' && ipArr[1] >= 16 && ipArr[1] <= 31) return true;
  if (ipArr[0] == '192' && ipArr[1] == '168') return true;
  return false;
}

/**
 * 获取替换处理后的url
 * @param src 原链接地址
 * @param options IReplaceOptions
 * @returns 处理后的新地址
 */
function getReplaceUrl(src, options) {
  const {
    replaceList = [],
    autoReplace = true,
    openUrlReplace = false,
    filterIntranet = true,
    onlyReplaceDomainAndIp = true,
    suffix = '',
    targetUrl = '',
  } = options || {};
  if (!openUrlReplace || typeof src !== 'string' || !src) return src;
  const windowDomain = window && window.location.hostname;
  // 内网访问时不进行替换
  if (autoReplace && (windowDomain === 'localhost' || checkIntranetIp(windowDomain))) {
    return src;
  }
  const originInfo = getOriginInfoFromSrc(src);
  const currentInfo = getOriginInfoFromSrc(targetUrl || (window && window.location.href) || '');
  const newUrlInfo = { ...originInfo };
  // 精确过滤replaceList
  if (replaceList.length) {
    for (let repUrl of replaceList) {
      const itemInfo = getOriginInfoFromSrc(repUrl);
      // 一此src只能匹配到一个domain
      if (itemInfo.domain === originInfo.domain) {
        newUrlInfo.protocol = onlyReplaceDomainAndIp ? originInfo.protocol : itemInfo.protocol || currentInfo.protocol;
        newUrlInfo.domain = currentInfo.domain;
        newUrlInfo.type = currentInfo.type;
        newUrlInfo.port = onlyReplaceDomainAndIp ? originInfo.port : itemInfo.port || currentInfo.port;
        break;
      }
    }
  }
  // 执行内网ip过滤
  if (filterIntranet && newUrlInfo.domain && newUrlInfo.type == 'ip' && checkIntranetIp(newUrlInfo.domain)) {
    newUrlInfo.protocol = onlyReplaceDomainAndIp ? originInfo.protocol : currentInfo.protocol;
    newUrlInfo.domain = currentInfo.domain;
    newUrlInfo.port = onlyReplaceDomainAndIp ? originInfo.port : currentInfo.port;
  }
  const newSrc = `${newUrlInfo.protocol}${newUrlInfo.domain}${newUrlInfo.port ? ':' + newUrlInfo.port : ''}${suffix}${
    newUrlInfo.restPath
  }`;
  return newSrc;
}

// 测试
// const t = getReplaceUrl('https://192.168.12.84:30077/home/dashboard/1.jpg', {
//   openUrlReplace: true,
//   onlyReplaceDomainAndIp: false,
//   targetUrl: 'http://aaa.33.4.4:33',
//   suffix: '/openresty',
// });
// console.log(t);

const config = process.env.NODE_ENV === 'development' ? window.config.dev : window.config.prod;

const replaceUrl = url => {
  return getReplaceUrl(url, config.urlReplace);
};

export { replaceUrl };
